import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';

import Button from '@ontruck/ontruck-react-components/lib/Button';

import {
  getOutcodes,
  getSelectedOutcodes,
  areSelectedOutcodesAreasHomogeneous,
} from 'redux/modules/outcodes/selectors';

import {
  loadOutcodes,
  loadMoreOutcodes,
  selectOutcode,
  opendOutcodeModal,
  closeOutcodeModal,
  editOutcodes,
} from 'redux/modules/outcodes/effects';

import MainContent from 'components/MainContent';
import OutcodeList from 'components/OutcodeList';
import { OutcodesEditModal } from 'components/Outcodes';
import OutcodeFilters from './filters';
import { Loading } from 'components/Loading';

import style from './style.module.scss';

const NOOP = () => {
  /*noop*/
};
const MAX_OUTCODES_SELECTED = 200;

class PostalCodesContainer extends Component {
  constructor(props) {
    super(props);
    this.handleRowClick = this.handleRowClick.bind(this);
    this.handleEditOutcode = this.handleEditOutcode.bind(this);
    this.handleSelectAllClick = this.handleSelectAllClick.bind(this);
  }

  handleSelectAllClick() {
    const { outcodes, selectOutcode } = this.props;

    selectOutcode(outcodes.map(({ outcode }) => outcode));
  }

  handleRowClick({ rowData }) {
    const { selectOutcode, selectedOutcodes } = this.props;

    const { outcode } = rowData;

    if (selectedOutcodes.length <= MAX_OUTCODES_SELECTED) {
      selectOutcode(outcode);
    }
  }

  handleEditOutcode(data) {
    const { editOutcodes } = this.props;

    const { selectedOutcodes } = this.props;

    editOutcodes({
      outcodes: selectedOutcodes.map(({ outcode }) => outcode),
      enabled: data.enabled,
      area: data.area,
    });
  }

  render() {
    const {
      outcodes,
      loadOutcodes,
      loading,
      loadingMore,
      total,
      loadMoreOutcodes,
      hasMoreOutcodes,
      pageSize,
      modalOpened,
      closeOutcodeModal,
      selectedOutcodes,
      editLoading,
      opendOutcodeModal,
      intl,
      editButtonEnabled,
    } = this.props;

    const t = intl.messages.containers.PostalCodes;

    const showEditButton = !!selectedOutcodes.length;

    return (
      <div className={style.container}>
        <div className={style.noGrow}>
          <MainContent>
            <h1>{t.title}</h1>
            <OutcodeFilters onChangeHandler={loadOutcodes} />
            {!loading ? (
              <div className={style.info}>
                <div className={style.totalText}>
                  <FormattedMessage
                    id="PostalCodes.totals"
                    defaultMessage={t.totals}
                    values={{ total: total.toString() }}
                  />
                </div>
                {showEditButton && (
                  <div>
                    <Button neutral onClick={opendOutcodeModal} disabled={!editButtonEnabled}>
                      {t.edit}
                    </Button>
                  </div>
                )}
              </div>
            ) : null}
          </MainContent>
        </div>
        <div className={style.grow}>
          {loading ? (
            <Loading size={60} className={style.loading} />
          ) : (
            !!outcodes.length && (
              <OutcodeList
                outcodes={outcodes}
                selectedOutcodes={selectedOutcodes}
                loadingOutcodes={loadingMore}
                totalOutcodes={total}
                onLoadMoreRows={loadingMore ? NOOP : loadMoreOutcodes}
                onRowClick={this.handleRowClick}
                onSelectAllClick={this.handleSelectAllClick}
                hasMoreOutcodes={hasMoreOutcodes}
                threshold={pageSize / 2}
                selectAllEnabled={total <= MAX_OUTCODES_SELECTED}
              />
            )
          )}
        </div>
        {modalOpened && (
          <OutcodesEditModal
            show={modalOpened}
            onSend={this.handleEditOutcode}
            onClose={closeOutcodeModal}
            outcodes={selectedOutcodes}
            editLoading={editLoading}
          />
        )}
      </div>
    );
  }
}

PostalCodesContainer.propTypes = {
  intl: PropTypes.any,
  outcodes: PropTypes.array,
  loadOutcodes: PropTypes.func,
  loading: PropTypes.bool,
  loadingMore: PropTypes.bool,
  total: PropTypes.number,
  loadMoreOutcodes: PropTypes.func,
  hasMoreOutcodes: PropTypes.bool,
  pageSize: PropTypes.number,
  selectOutcode: PropTypes.func,
  opendOutcodeModal: PropTypes.func,
  editOutcodes: PropTypes.func,
  selectedOutcodes: PropTypes.array,
  modalOpened: PropTypes.bool,
  closeOutcodeModal: PropTypes.func,
  editButtonEnabled: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  outcodes: getOutcodes(state),
  selectedOutcodes: getSelectedOutcodes(state),
  editButtonEnabled: areSelectedOutcodesAreasHomogeneous(state),
  hasMoreOutcodes: !!state.outcodes.next,
  loading: state.outcodes.loading,
  loadingMore: state.outcodes.loadingMore,
  editLoading: state.outcodes.editLoading,
  total: state.outcodes.count,
  pageSize: state.outcodes.pageSize,
  modalOpened: state.outcodes.modalOpened,
});

const mapDispatchToProps = {
  loadOutcodes,
  loadMoreOutcodes,
  selectOutcode,
  opendOutcodeModal,
  closeOutcodeModal,
  editOutcodes,
};

export const PostalCodes = injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(PostalCodesContainer)
);
